import { successStoryImages } from "@/data/landingData";
import { useLanguage } from "@/context/LanguageContext";

const SuccessSection = () => {
  const { copy } = useLanguage();

  return (
    <section className="section" id="success" data-testid="success-section">
      <div className="container" data-testid="success-container">
        <div className="section-header">
          <p className="section-kicker" data-testid="success-kicker">
            {copy.success.kicker}
          </p>
          <h2 className="section-title" data-testid="success-title">
            {copy.success.title}
          </h2>
        </div>
        <div className="success-grid" data-testid="success-grid">
          {copy.success.stories.map((story, index) => (
            <article className="success-card" key={story.title} data-testid={`success-card-${index}`}>
              <img
                src={successStoryImages[index]}
                alt={story.title}
                loading="lazy"
                data-testid={`success-image-${index}`}
              />
              <div className="success-content" data-testid={`success-content-${index}`}>
                <h3 data-testid={`success-title-${index}`}>{story.title}</h3>
                <p data-testid={`success-description-${index}`}>{story.description}</p>
                <div className="tag-row" data-testid={`success-tags-${index}`}>
                  {story.tags.map((tag, tagIndex) => (
                    <span key={tag} className="tag" data-testid={`success-tag-${index}-${tagIndex}`}>
                      {tag}
                    </span>
                  ))}
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default SuccessSection;